import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Observable, Subscription } from "rxjs";
import { ISOTVoucher } from "../../services";
import { ISOTService } from '../../services';

export interface ScanVoucherData {
  startScanVoucher: () => void;
  cancelScanVoucher: () => void
  scanVoucherSubscription: Observable<ISOTVoucher>
  sot_service: ISOTService;
  /** When true, the dialog is shown as part of the benefits-redemption flow
   *  and uses benefit-specific langkeys for title and scan info. */
  isBenefitsRedemption?: boolean;
}

@Component({
  selector: "voucherScanDialog",
  templateUrl: "./voucherScanDialog.component.html",
  styleUrls: ["./voucherScanDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VoucherScanDialogComponent implements OnInit, OnDestroy {
  public constructor(public dialogRef: MatDialogRef<VoucherScanDialogComponent, "voucher" | "manual" | "cancel">
    , @Inject(MAT_DIALOG_DATA) public data: ScanVoucherData) {
  }

  private _scanVoucherSubscription: Subscription;

  public get isModeOne(): boolean {
    return this.data.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.data.sot_service.Accessabilty.useModeTwo;
  }

  public get titleKey(): string {
    const me = this;
    return me.data.isBenefitsRedemption ? "voucherscan_benefits_title" : "voucherscan_title";
  }

  public get infoKey(): string {
    const me = this;
    return me.data.isBenefitsRedemption ? "voucherscan_benefits_scaninfo" : "voucherscan_info";
  }

  ngOnInit(): void {
    const me = this;
    me.data.startScanVoucher();
    me._scanVoucherSubscription = me.data.scanVoucherSubscription.subscribe((voucher) => {
      me.dialogRef.close("voucher");
    })
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._scanVoucherSubscription) {
      me._scanVoucherSubscription.unsubscribe();
    }
  }

  public openVoucherCodeInput() {
    const me = this;
    me.data.cancelScanVoucher();
    me.dialogRef.close("manual");
  }

  public cancel(): void {
    const me = this;
    me.data.cancelScanVoucher();
    me.dialogRef.close("cancel");
  }

}